<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/zhaoshang/customer' }">客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>修改客户</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">修改客户</span>
      </div>

      <el-form :model="form" ref="formRef" :rules="formRules" label-width="120px" :inline="false" size="normal" style="max-width:600px">
        <!-- 客户标题 -->
        <el-form-item label="客户名称：" prop="title">
          <el-input v-model="form.title" placeholder="地区+客户称呼，如北京张总" maxlength="50"></el-input>
        </el-form-item>

        <!-- 联系人姓名 -->
        <el-form-item label="联系人姓名：" prop="name">
          <el-input v-model="form.name" placeholder="请输入联系人姓名，2-15个字符" maxlength="15"></el-input>
        </el-form-item>

        <!-- 手机号 -->
        <el-form-item label="手机号：" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入11位有效手机号" maxlength="11"></el-input>
        </el-form-item>

        <!-- 身份证号 -->
        <el-form-item label="身份证号：" prop="idCard">
          <el-input v-model="form.idCard" :placeholder="idCardRequired ? '请输入18位身份证号' : '请输入18位身份证号（选填）'" maxlength="18"></el-input>
        </el-form-item>

        <!-- 客户来源 -->
        <el-form-item label="客户来源：" prop="from">
          <el-select v-model="form.from" placeholder="请选择客户来源" style="width: 100%">
            <el-option v-for="item in fromList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <!-- 归属人（只读显示） -->
        <el-form-item label="创建人：">
          <el-input v-model="form.creatorName" disabled placeholder="归属人不可修改"></el-input>
        </el-form-item>

        <!-- 创建人堆雪球账号 -->
        <el-form-item label="归属人微信：" prop="creatorDxqId">
          <el-select v-model="form.creatorDxqId" placeholder="请选择创建人堆雪球账号（选填）" filterable style="width: 100%" @change="onCreatorDxqChange" :disabled="!isCreatorDxqEditable">
            <el-option label="不选择" value=""></el-option>
            <el-option v-for="item in dxqAccountList" :key="item.id" :label="item.nickname" :value="item.id">
              <div style="display: flex; align-items: center;">
                <img :src="item.avatar" alt="头像" style="width: 32px; height: 32px; border-radius: 50%; margin-right: 10px;">
                <span>{{ item.nickname }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 客户堆雪球账号/微信好友 -->
        <el-form-item label="客户微信：" prop="customerDxqId">
          <el-select v-model="form.customerDxqId" placeholder="请选择客户的微信好友（选填）" style="width: 100%" :disabled="!form.creatorDxqId" filterable remote :remote-method="searchWechatFriends" :loading="loadingWechatFriends">
            <el-option label="不选择" value=""></el-option>
            <el-option v-for="item in wechatFriendList" :key="item.id" :label="item.nickname" :value="item.id">
              <div style="display: flex; align-items: center;">
                <img :src="item.avatar" alt="头像" style="width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
                <span>{{ item.nickname }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 备注 -->
        <el-form-item label="备注：" prop="remark">
          <el-input v-model="form.remark" type="textarea" placeholder="请输入备注信息（最多500字符）" maxlength="500" rows="4"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="okClickHandler">修改客户</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>

    </el-card>

    <!-- 操作记录（detail 接口附带） -->
    <el-card class="box-card" style="margin-top: 15px" v-if="operationLogs.length > 0">
      <div slot="header"><span style="font-weight: bold">操作记录</span></div>
      <el-table :data="operationLogs" border size="mini">
        <el-table-column label="动作" width="130">
          <template slot-scope="scope">{{ actionText(scope.row.action) }}</template>
        </el-table-column>
        <el-table-column prop="operatorName" label="操作人" width="100"></el-table-column>
        <el-table-column prop="remark" label="说明" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column label="时间" width="150">
          <template slot-scope="scope">{{ scope.row.createDate | timeFormat }}</template>
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
import { fromList } from '@/utility/staticData'
import { actionText } from '../../utils/operationLogMap'

export default {
  filters: {
    timeFormat (val) {
      if (!val) return '-'
      const d = new Date(val)
      const p = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    }
  },
  data () {
    // 手机号验证
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的11位手机号'))
      } else {
        callback()
      }
    }

    // 身份证号验证（原值为历史脏数据且未修改时放行，仅新值必须合法）
    const validateIdCard = (rule, value, callback) => {
      if (value && value !== this.originalIdCard && !/^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/.test(value)) {
        callback(new Error('请输入正确的18位身份证号'))
      } else {
        callback()
      }
    }

    return {
      // 当前账号的信息
      accountInfo: {},

      // 操作日志（detail 接口附带）
      operationLogs: [],
      actionText,

      // 表单数据
      form: {
        title: '', // 客户标题
        name: '', // 联系人姓名
        mobile: '', // 手机号
        idCard: '', // 身份证号
        from: '', // 客户来源
        creatorName: '', // 创建人姓名（只读）
        creatorDxqId: '', // 创建人堆雪球ID
        customerDxqId: '', // 客户堆雪球ID
        remark: '' // 备注
      },
      // 客户来源列表
      fromList: fromList, // 客户来源列表
      // 堆雪球账号列表
      dxqAccountList: [],
      // 微信好友列表
      wechatFriendList: [],
      // 是否加载中
      loadingWechatFriends: false,
      // 归属人微信字段是否可编辑
      isCreatorDxqEditable: true,
      // 身份证号是否必填（已登记身份证号的客户不允许清空，历史空数据不强制）
      idCardRequired: false,
      // 回显的身份证号原值（存量历史数据可能格式非法，未修改时跳过格式校验）
      originalIdCard: '',

      // 表单验证规则
      formRules: {
        title: [
          { type: 'string', required: true, message: '请输入客户标题', trigger: 'blur' },
          { type: 'string', min: 2, max: 50, message: '客户标题必须为2-50个字符', trigger: 'blur' }
        ],
        name: [
          { type: 'string', required: true, message: '请输入联系人姓名', trigger: 'blur' },
          { type: 'string', min: 2, max: 15, message: '联系人姓名必须为2-15个字符', trigger: 'blur' }
        ],
        mobile: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        idCard: [
          { required: false, message: '该客户已登记身份证号，不能清空', trigger: 'blur' },
          { validator: validateIdCard, trigger: 'blur' }
        ],
        from: [
          { required: true, message: '请选择客户来源', trigger: 'change' }
        ],
        creatorDxqId: [],
        customerDxqId: [],
        remark: [
          { type: 'string', max: 500, message: '备注信息不能超过500个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getAccountInfo()
    this.initEditableStatus()
    this.getDxqAccountList()
  },
  methods: {
    // 获取当前登录账号的信息
    getAccountInfo () {
      this.accountInfo.level = window.sessionStorage.getItem('level')
      this.accountInfo.employeeId = window.sessionStorage.getItem('employeeId') || ''
      this.accountInfo.employeeName = window.sessionStorage.getItem('employeeName') || ''
      this.accountInfo.department = window.sessionStorage.getItem('department') || ''
      this.accountInfo.job = window.sessionStorage.getItem('job') || ''
      this.accountInfo.bindDxqId = window.sessionStorage.getItem('bindDxqId') || ''
    },

    // 根据角色初始化字段可编辑状态
    initEditableStatus () {
      const level = parseInt(this.accountInfo.level)
      const job = this.accountInfo.job

      // 管理员（level <= 1）：可编辑
      if (level <= 1) {
        this.isCreatorDxqEditable = true
        return
      }

      // 总监：可编辑
      if (job === '总监') {
        this.isCreatorDxqEditable = true
        return
      }

      // 普通员工或主管（job='员工' job='主管'）：不可编辑
      if (job === '员工' || job === '主管') {
        this.isCreatorDxqEditable = false
      }
    },
    // 获取堆雪球账号列表
    async getDxqAccountList () {
      try {
        const { data: res } = await this.$http.get('zhaoshang/customer/dxq-accounts')
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.dxqAccountList = res.data || []
        // 获取堆雪球账号列表后再加载客户详情
        this.getInfo()
      } catch (error) {
        this.$message.error('获取堆雪球账号列表失败')
      }
    },

    // 获取客户详情
    async getInfo () {
      try {
        const { data: res } = await this.$http.get(`zhaoshang/customer/detail/${this.$route.params.id}`)
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }

        // 操作记录（detail 接口附带，最近 20 条）
        this.operationLogs = res.data.operationLogs || []

        // 填充表单数据
        this.form.title = res.data.title || ''
        this.form.name = res.data.name || ''
        this.form.mobile = res.data.mobile || ''
        this.form.idCard = res.data.idCard || ''
        this.form.from = res.data.from || ''
        this.form.creatorName = res.data.creatorName || ''
        this.form.creatorDxqId = res.data.creatorDxqId || ''
        this.form.customerDxqId = res.data.customerDxqId || ''
        this.form.remark = res.data.remark || ''

        // 已登记身份证号的客户不允许清空（2026-09-09 起成交客户必须填写身份证号，历史空数据不强制补填）
        this.idCardRequired = !!this.form.idCard
        this.formRules.idCard[0].required = this.idCardRequired
        this.originalIdCard = this.form.idCard

        // 如果有创建人堆雪球ID，加载微信好友列表
        if (this.form.creatorDxqId) {
          this.loadWechatFriends()
        }
      } catch (error) {
        this.$message.error('获取客户详情失败')
      }
    },

    // 加载微信好友列表（用于回显）
    async loadWechatFriends () {
      if (!this.form.creatorDxqId) return

      try {
        const params = {
          wechatAccountId: this.form.creatorDxqId,
          wechatFriendId: this.form.customerDxqId,
          keyword: ''
        }
        const { data: res } = await this.$http.get('zhaoshang/customer/wechat-friends', { params })
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.wechatFriendList = res.data || []
      } catch (error) {
        console.error('加载微信好友列表失败', error)
      }
    },

    // 归属人堆雪球账号变化时，强制清空客户微信选择
    onCreatorDxqChange () {
      this.form.customerDxqId = ''
      this.wechatFriendList = []
    },

    // 搜索微信好友
    async searchWechatFriends (keyword) {
      if (!this.form.creatorDxqId) {
        this.$message.warning('请先选择创建人堆雪球账号')
        return
      }

      this.loadingWechatFriends = true
      try {
        const params = {
          wechatAccountId: this.form.creatorDxqId,
          keyword: keyword
        }
        const { data: res } = await this.$http.get('zhaoshang/customer/wechat-friends', { params })
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.wechatFriendList = res.data || []
      } catch (error) {
        this.$message.error('获取微信好友列表失败')
      } finally {
        this.loadingWechatFriends = false
      }
    },

    // 点击修改按钮
    async okClickHandler () {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return false

        const submitData = {
          title: this.form.title,
          name: this.form.name,
          mobile: this.form.mobile,
          idCard: this.form.idCard || '',
          from: this.form.from,
          creatorDxqId: this.form.creatorDxqId || '',
          customerDxqId: this.form.customerDxqId || '',
          remark: this.form.remark || ''
        }

        try {
          const { data: res } = await this.$http.put(`zhaoshang/customer/modify/${this.$route.params.id}`, submitData)
          if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
          this.$message.success(res.meta.msg)
          this.goBack()
        } catch (error) {
          this.$message.error('修改客户失败')
        }
      })
    },

    // 返回
    goBack () {
      // 获取传递过来的状态参数
      const query = { ...this.$route.query }

      // 构建返回URL
      const queryString = Object.keys(query).length > 0
        ? '?' + Object.entries(query).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')
        : '?tabs=customer'

      this.$router.push('/zhaoshang/customer' + queryString)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
